module.exports = __webpack_public_path__ + "img/order-step1-c.42479686.png";